__turbopack_context__.v({
  "old-versions": "Terms-module-scss-module__ZdbMfq__old-versions",
  "terms": "Terms-module-scss-module__ZdbMfq__terms",
});
